import { client } from './client';

export const validateMeterpoint = (params) =>
  client('premises-service-point', {
    method: 'GET',
    params
  });
